import BaseComponent from '../base-component/base-component'

class Card extends BaseComponent {}

export default Card
